//home.js 用于获取首页json数据

import req from './http.js'  //引入封装好的axios

//在这里定义了一个登陆的接口，把登陆的接口暴露出去给组件使用
export const GETLISTDATA =params=>req('get','cms/article/list/?catid='+params.catid+'&pageNum='+params.pageNum+'&pageSize='+params.pageSize+'&orderColumn=sort desc,publish_time desc',params);
export const GETADDATA =params=>req('get','system/advert/'+params.id);
export const GETDATA =params=>req('get','cms/article/'+params.id,params);
export const GETDATAS =params=>req('get','cms/branch/'+params.id);
